import { Stack } from "@mui/material";
import { DateField } from "components/Forms/DateField";
import { RadioGroupField } from "components/Forms/RadioGroupField";
import { Control, FieldValues, Path, UseFormSetValue, UseFormWatch } from "react-hook-form";

type AgencyDueDateFieldValues = {
  dueDate?: string | null;
  dueDateIsAnniversary?: boolean | null;
};

type AgencyDueDateFieldsProps<T extends AgencyDueDateFieldValues & FieldValues> = {
  control: Control<T>;
  watch: UseFormWatch<T>;
  setValue: UseFormSetValue<T>;
};

export function AgencyDueDateFields<T extends AgencyDueDateFieldValues & FieldValues>({
  control,
  watch,
  setValue,
}: AgencyDueDateFieldsProps<T>) {
  const dueDateIsAnniversary = watch("dueDateIsAnniversary" as Path<T>) ?? false;

  return (
    <Stack gap={1} sx={{ mb: 4 }}>
      <RadioGroupField
        name={"dueDateIsAnniversary" as Path<T>}
        label="CUPA Due Date"
        control={control}
        hideErrors
        onChange={({ value }: { value: boolean }) => {
          if (value) {
            setValue("dueDate" as Path<T>, null as never, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }
        }}
        radioOptions={[
          { value: false, label: "Fixed date" },
          { value: true, label: "Anniversary of submission per facility" },
        ]}
      />
      {!dueDateIsAnniversary && (
        <DateField
          name={"dueDate" as Path<T>}
          label="Due Date"
          datePickerProps={{ views: ["month", "day"] }}
          control={control}
          hideErrors
        />
      )}
    </Stack>
  );
}
